export default __webpack_public_path__ + "images/set/swish-icon.png";